module.exports = __webpack_public_path__ + "img/Weapon_189.4bcf0258.png";